import AxiosInstance from "../instance";
import {emptyFn} from "../utils";


const createTextExtractionJob = async (formData: FormData) => {
    const response = await AxiosInstance.getInstance().post("/textract", formData);

    return response;
};

const getTextExtractionJobResult = async (jobId: string) => {
    const response = await AxiosInstance.getInstance().get("/textract", {
        params: {
            id: jobId
        }
    }).catch(emptyFn);

    return response;
};

export {createTextExtractionJob, getTextExtractionJobResult};


// WEBPACK FOOTER //
// ./src/api/models/TextExtraction.ts